import { z } from 'zod/v4';

export function getFixedOrMutableIdSchema(requiredError?: string, valueValidator?: z.ZodString) {
  const valueSchema = valueValidator ?? z.string();

  return z.discriminatedUnion('kind', [
    z.object({
      kind: z.literal('fixed'),
      value: valueSchema,
    }),
    z.object({
      kind: z.literal('mutable'),
      value: requiredError ? valueSchema.nonempty(requiredError) : valueSchema,
    }),
  ]);
}

export type FixedOrMutableIdFormValue = z.infer<ReturnType<typeof getFixedOrMutableIdSchema>>;

export function getDefaultFixedOrMutableIdValue(value: string | undefined, backupValue: string = ''): FixedOrMutableIdFormValue {
  return value
    ? {
        kind: 'fixed',
        value,
      }
    : {
        kind: 'mutable',
        value: backupValue,
      };
}
